import {
  useAddAccountToUserMutation,
  useAllAccountOfUserQuery,
  useGetAllInvestmentsQuery,
} from '../../../../generated/graphql'
import { graphqlRequestClient, queryClient } from '../../../../queries/client'
import { useFormik } from 'formik'
import Toast, { ToastType } from '../../../../utils/toast'
import { AddAccountSchema } from '../AccountHelper'
import { getAuth, JwtPayload } from '../../../../app/modules/auth'
import jwtDecode from 'jwt-decode'
import { useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'react-bootstrap'

type Props = {
  show: boolean
  handleClose: () => void
}

const initialValues = {
  accountName: '',
}

function AddAccountPopup(props: Props) {
  const [loading, setLoading] = useState<boolean>(false)
  const mutateAddAccount = useAddAccountToUserMutation<Error>(graphqlRequestClient, {}, {})
  const auth = getAuth()!
  const jwt = jwtDecode<JwtPayload>(auth)

  const formik = useFormik({
    initialValues,
    validationSchema: AddAccountSchema,
    onSubmit: (values) => {
      setLoading(true)
      mutateAddAccount.mutate(
        {
          input: {
            name: values.accountName.trim(),
            userEmailId: jwt.emailId!,
            isAdmin: true,
          },
        },
        {
          onSuccess: () => {
            setLoading(false)
            queryClient.invalidateQueries(useAllAccountOfUserQuery.getKey())
            queryClient.invalidateQueries(useGetAllInvestmentsQuery.getKey())
            Toast('Account created Successfully', ToastType.success)
            formik.resetForm()
            props.handleClose()
          },
          onError: (error: any) => {
            setLoading(false)
            Toast(`${error.response.errors[0].message}`, ToastType.error)
          },
        }
      )
    },
  })

  return (
    <Modal
      show={props.show}
      dialogClassName='modal-dialog modal-dialog-centered mw-600px'
      backdrop={true}
      aria-hidden='true'
      id='kt_add_account_modal'
    >
      <ModalHeader className='justify-content-between'>
        <h1 className='fw-bolder'>Add Account</h1>
        <button
          type='button'
          className='btn btn-transparent border-sm border border-gray-700 text-hover-primary border-hover-primary'
          onClick={() => props.handleClose()}
        >
          Close
        </button>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className='pb-5'>
            <h3 className='required'>Account Name :</h3>
            <input
              className='form-control form-control-lg'
              type='text'
              autoComplete='off'
              placeholder='Enter Account Name'
              {...formik.getFieldProps('accountName')}
            />
            {formik.errors.accountName && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>{formik.errors.accountName}</div>
              </div>
            )}
          </div>
          <div className='d-flex justify-content-end'>
            <button className='btn btn-primary' type='submit' disabled={loading}>
              {!loading && <span className='indicator-label fw-bold'>Submit</span>}
              {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default AddAccountPopup
